/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalcolaTotaleOreMensiliResponseDTO
 */
export interface CalcolaTotaleOreMensiliResponseDTO {
    /**
     * 
     * @type {number}
     * @memberof CalcolaTotaleOreMensiliResponseDTO
     */
    oreTotaliLavorate?: number;
    /**
     * 
     * @type {number}
     * @memberof CalcolaTotaleOreMensiliResponseDTO
     */
    oreTotaliMese?: number;
}

/**
 * Check if a given object implements the CalcolaTotaleOreMensiliResponseDTO interface.
 */
export function instanceOfCalcolaTotaleOreMensiliResponseDTO(value: object): value is CalcolaTotaleOreMensiliResponseDTO {
    return true;
}

export function CalcolaTotaleOreMensiliResponseDTOFromJSON(json: any): CalcolaTotaleOreMensiliResponseDTO {
    return CalcolaTotaleOreMensiliResponseDTOFromJSONTyped(json, false);
}

export function CalcolaTotaleOreMensiliResponseDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalcolaTotaleOreMensiliResponseDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'oreTotaliLavorate': json['oreTotaliLavorate'] == null ? undefined : json['oreTotaliLavorate'],
        'oreTotaliMese': json['oreTotaliMese'] == null ? undefined : json['oreTotaliMese'],
    };
}

export function CalcolaTotaleOreMensiliResponseDTOToJSON(json: any): CalcolaTotaleOreMensiliResponseDTO {
    return CalcolaTotaleOreMensiliResponseDTOToJSONTyped(json, false);
}

export function CalcolaTotaleOreMensiliResponseDTOToJSONTyped(value?: CalcolaTotaleOreMensiliResponseDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'oreTotaliLavorate': value['oreTotaliLavorate'],
        'oreTotaliMese': value['oreTotaliMese'],
    };
}

